import React from 'react'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import electrician from "../images/Electrician.jpg";
import electrician_img from "../images/Electrician photo.jpg";
import electrician_iti from "../images/Electrician _iti.jpg";
import electrician_imgnew from "../images/Electrician _img.jpg"

import copaiti from "../images/copa_iti.jpg";
import copaimg from "../images/COPA Maa Tara Foundation.jpg";
import copamtf from "../images/COPA NEW.jpg";
import COPA_iti from "../images/COPA WORKSHOP.jpg";

import copaitinew from "../images/COPA.jpg";
import copaimgnew from "../images/COPA_IMG.jpg"
import copaitiphoto from "../images/MTF_COPA.jpg";
import COPA_itinew from "../images/COPA _ITI.jpg"

import fitter from "../images/Fitte img.jpg";
import fitterimg from "../images/fitter murshidabad.jpg";
import fittermtf from "../images/fitter.jpg";
import fitternew from "../images/Fitter Course Berhampore.jpg"

import fitter5 from "../images/fitteratmaa tara_foundation.jpg";
import fitterimg2 from "../images/Fitter MTF.jpg";
import bestfittercourse from "../images/FITTER _iti.jpg";
import fitternew2 from "../images/Fitter_course.jpg"

import ITILAB from "../images/IT LAB _IMG.jpg";
import itilabmurshidabad from "../images/it lab.jpg";
import itilabpage from "../images/IT Lab at Murshidabad.jpg";
import itilabphoto from "../images/it lab.jpg"


function Itiphoto() {
  return (
    <div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={electrician} className="card-img-top" alt="electrician" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Electrician </h5>
                                                

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={electrician_img} className="card-img-top" alt="electrician_img"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Electrician </h5>
                                                
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={electrician_iti} className="card-img-top" alt="electrician_iti" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Electrician </h5>
                                                
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={electrician_imgnew} className="card-img-top" alt="electrician_img" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Electrician                                  </h5>
                                       
                                                
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


             <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={copaiti} className="card-img-top" alt="copaiti" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">COPA </h5>
                                                

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={copaimg} className="card-img-top" alt="copaimg"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">COPA </h5>
                                                
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={copamtf} className="card-img-top" alt="copa" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">COPA </h5>
                                                
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={COPA_iti} className="card-img-top" alt="COPA_iti" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >COPA ITI                              </h5>
                                       
                                                
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={copaitinew} className="card-img-top" alt="copaiti" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">COPA </h5>
                                                

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={copaimgnew} className="card-img-top" alt="copaimg"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">COPA </h5>
                                                
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={copaitiphoto} className="card-img-top" alt="copaitiphoto" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">COPA </h5>
                                                
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={COPA_itinew} className="card-img-top" alt="COPA_iti" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >COPA ITI                              </h5>
                                       
                                                
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={fitter} className="card-img-top" alt="fitter" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">FITTER</h5>
                                                

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={fitterimg} className="card-img-top" alt="fitterimg"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">FIITER</h5>
                                                
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={fittermtf} className="card-img-top" alt="fittermtf"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">FITTER </h5>
                                                
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={fitternew} className="card-img-top" alt="fitternew" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >FITTER                             </h5>
                                       
                                                
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={fitter5} className="card-img-top" alt="fitter" />

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">FITTER</h5>
                                                

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={fitterimg2} className="card-img-top" alt="fitterimg"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">FIITER</h5>
                                                
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={bestfittercourse} className="card-img-top" alt="bestfittercourse"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">FITTER </h5>
                                                
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={fitternew2} className="card-img-top" alt="fitternew" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >FITTER                             </h5>
                                       
                                                
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


                <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={ITILAB} className="card-img-top" alt="ITILAB"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">ITI LAB</h5>
                                                

                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={itilabmurshidabad} className="card-img-top" alt="itilabmurshidabad"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">ITI LAB</h5>
                                                
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={itilabpage} className="card-img-top" alt="itilabpage"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">ITI LAB</h5>
                                                
                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='maatarafoundtion'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={itilabphoto} className="card-img-top" alt="itilabphoto"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >ITI LAB                             </h5>
                                       
                                                
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
    </div>
  )
}

export default Itiphoto